// Imports
import { lighten, saturate } from 'polished';
import { createGlobalStyle } from 'styled-components/macro';
import { GeneratedThemeProps } from './template-style';


// Global styles
const NatureStyle = createGlobalStyle<{ theme: GeneratedThemeProps }>`
	#root, #storybook-root {
		min-height: 100vh;
		font-family: ${(props) => props.theme.fontFamily};
		-webkit-font-smoothing: auto;
        color: ${(props) => props.theme.baseColor};
		background: ${(props) => saturate(0.2, lighten(0.3, props.theme.baseColor))};
		background: linear-gradient(to bottom, rgba(0, 0, 0, 0.4) 0%, rgba(0, 0, 0, 0) 31.25rem), url(${(props) =>
			`https://cdn.${process.env.REACT_APP__ENVIRONMENT_HOSTNAME}/images/template-resources/${
				props.theme.isAutumn ? '26' : '28'
			}/background.jpg`}) repeat;
	}
`;

export default NatureStyle;
